import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-top-alert-container" }
const _hoisted_2 = { class: "app-top-alert__content" }

import IconCross from '@/icons/icon-cross.vue';
import useTopAlertsStore from '@/store/top-alerts';
import { computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTopAlert',
  setup(__props) {

const topAlertStore = useTopAlertsStore();
const isShow = computed(() => topAlertStore.message);
const alertType = computed(() => topAlertStore.type);
const { hideAlert } = topAlertStore;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'app-top-alert',
        `app-top-alert--${alertType.value}`,
      ])
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(topAlertStore).message), 1),
          _createElementVNode("button", {
            type: "button",
            class: "app-top-alert__close-btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(hideAlert) && _unref(hideAlert)(...args)), ["prevent"]))
          }, [
            _createVNode(IconCross)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})